// Hook to fetch the /tenantToken partner token

/*  Shared  */
import { Response } from 'application/Shared/Helpers';
import { debug } from 'application/Shared/Utils';

/*  NPM  */
import axios from 'axios';

/*  React  */
import { useEffect, useState } from 'react';

export const useFetchTenantPartnerToken = (params) => {
    const [partnerToken, setPartnerToken] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const { CancelToken } = axios;
        const source = CancelToken.source();

        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await axios.get('/tenantToken', {
                    cancelToken: source.token,
                    params
                });
                if (!Response.hasData(response)) {
                    debug.e('No Token Found', response);
                }
                const record = Response.getOne(response);
                if (record !== null && Object.keys(record).length !== 0) {
                    setPartnerToken(record.token);
                } else {
                    setPartnerToken(false);
                }
            } catch (error) {
                debug.e('Unable to get Token', error);
            }
            setLoading(false);
        };

        fetchData();
    }, [params]);

    return {
        loading,
        partnerToken
    };
};
